// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__MXOF8yLbIt9PG","container":"container__b7U9tlP+jc+vL","title":"title__51kJnlbBj1PdG","info":"info__mErQDW10LL-B7","copy_code":"copy_code__a767v7Lmm9ZLo"};